import { createFileRoute } from '@tanstack/react-router';
import { ExchangeFlow } from '@/features/exchange/exchange-flow';

/** نظام صرف عملات: ordinary prices (currency.md section 3.1). */
export const Route = createFileRoute('/_app/exchange')({
  component: () => <ExchangeFlow vip={false} />,
});
